import axios from 'axios';
import {extname} from 'path';
import uuid from 'uuid';
import {STORE_TREEZ_API_URL} from './Constants';

export const uploadImage = async (file: File) => {
    const filename = `${uuid()}${extname(file.name)}`;

    const formData = new FormData();
    formData.append('referenceType', 'store');
    formData.append('referenceId', 'launch');
    formData.append('key', 'storeImages');
    formData.append('tenantId', 'plan');
    formData.append('image', file, filename);

    return axios.post(`${STORE_TREEZ_API_URL}/s3/images`, formData);
};
